export const createUserModel = schema => {
  return new schema.Entity(
    'User', {},
  );
};
